import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Container, Row } from 'react-bootstrap';
import useModal from '../../hooks/useModal';
import RetireSummaryModal from '../../pages/widgets/retireOnlineModals/actionsRequired/RetireSummaryModal';
import MailInFormsModal from '../../pages/widgets/retireOnlineModals/MailInFormsModal';
import { DateFormats, formatDate } from '../../utils/utils';
import Button from '../Button';
import GenericCards from '../GenericCards';
import { ModalManagementStore } from '../../providers/modal-manager';
import { useContext } from 'react';
import Link from '../Link';

const RetireOnlineRequiredActions = () => {
  const { openModal } = useContext(ModalManagementStore);
  const [
    showMailInFormsModal,
    handleShowMailInFormsModal,
    handleCloseMailInForms,
  ] = useModal();

  const [showSummaryModal, handleShowSummaryModal, handleCloseSummaryModal] =
    useModal();

  const initialDate = new Date();

  return (
    <section className="d-lg-flex flex-lg-row pt-10">
      <Container className={`p-0 custom-outlined-card`}>
        <Card className={'bg-white'}>
          <Card.Title>
            <Row>
              <Col className="mb-0 h5 flex-column">Almost there</Col>
              <Col className="pt-2 text-light-grey text-fs-6 flex-column text-end">
                26 more days
              </Col>
            </Row>
          </Card.Title>
          <Card.Body>
            <Row>
              <Col className="col-12 col-lg-3">
                <GenericCards
                  variant="transperant"
                  className="d-flex flex-column rounded-1 p-lg-0 py-md-2"
                >
                  <h5 className="lh-sm mb-0 dark text-reset">
                    Submission Details
                  </h5>
                  <span className="fw-light text-caption lh-xs">
                    {`Submitted: ${formatDate(initialDate, DateFormats.SHORT)}`}
                  </span>
                  <span className="fw-light text-caption lh-xs">
                    Status: Pending
                  </span>
                  <span>
                    <Button
                      variant="primary-outline"
                      className="mt-9"
                      onClick={handleShowSummaryModal}
                    >
                      Show Summary
                    </Button>
                  </span>
                </GenericCards>
              </Col>
              <Col className="col-12 col-lg-4">
                <GenericCards
                  variant="transperant"
                  className="d-flex flex-column p-lg-0 rounded-1 dark py-md-2"
                >
                  <h5 className="lh-sm mb-0 text-reset">Download Record</h5>
                  <span className="fw-light text-caption lh-xs">
                    You will automatically receive written confirmation of this
                    transaction by U.S. Mail or
                  </span>
                  <span>
                    <Link
                      href={`${
                        process.env.PUBLIC_URL
                      }/${'retirement-package-demo-example_v1.pdf'}`}
                      target={'_blank'}
                    >
                      <Button
                        variant="primary-outline"
                        className="mt-3 mb-3"
                        leftIcon={light('file-arrow-down')}
                      >
                        Download/Print
                      </Button>
                    </Link>
                  </span>
                </GenericCards>
              </Col>
              <Col className="col-12 col-lg-5 d-flex lg-justify-content-end py-1">
                <GenericCards variant={'red'}>
                  <h5 className="text-reset">Actions required</h5>
                  <Row>
                    <Col>
                      <span className="fw-normal text-caption lh-xs pt-7 d-flex align-items-center">
                        Required documents
                      </span>
                    </Col>
                  </Row>
                  <Row className="fw-normal text-caption lh-xs pt-7 d-flex align-items-center">
                    <Col>
                      <FontAwesomeIcon icon={light('check')} className="pe-3" />
                      <span>Beneficiary Designation Authorization Form</span>
                    </Col>
                  </Row>
                  <Row className="fw-normal text-caption lh-xs pt-3 d-flex align-items-center">
                    <Col>
                      <FontAwesomeIcon icon={light('check')} className="pe-3" />
                      <span>Spousal Waiver</span>
                    </Col>
                  </Row>
                  <Row className="fw-normal text-caption lh-xs py-7 d-flex">
                    <Col>
                      <span>Step 1</span>
                    </Col>
                  </Row>
                  <Row className="fw-normal text-caption">
                    <Col className="col-12">
                      <section className="d-flex flex-column flex-lg-row ">
                        <Link
                          href={`${
                            process.env.PUBLIC_URL
                          }/${'retirement-package-demo-example_v1.pdf'}`}
                          target={'_blank'}
                        >
                          <Button
                            variant="danger-transparent-white"
                            size="sm"
                            leftIcon={light('file-arrow-down')}
                          >
                            {'Download Forms & Print'}
                          </Button>
                        </Link>
                      </section>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="fw-normal text-caption lh-xs pt-7 d-flex">
                      <span>Step 2</span>
                    </Col>
                  </Row>

                  <section className="pt-3 d-flex flex-column flex-lg-row justify-content-center ">
                    <Button
                      variant="danger-shadow"
                      size="sm"
                      className={'mt-3'}
                      rightIcon={light('mailbox')}
                      onClick={handleShowMailInFormsModal}
                    >
                      Mail In
                    </Button>
                    <div className="fw-normal text-caption text-center mt-lg-8 mt-4 px-4">
                      or
                    </div>
                    <Button
                      variant="danger-shadow"
                      size="sm"
                      className={'mt-3'}
                      leftIcon={light('upload')}
                      onClick={() => openModal('document-upload')}
                    >
                      Upload Document
                    </Button>
                  </section>
                </GenericCards>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <MailInFormsModal
        showModal={showMailInFormsModal}
        handleClose={handleCloseMailInForms}
      />
      <RetireSummaryModal
        showRetireSummaryModal={showSummaryModal}
        handleCloseRetireSummaryModal={handleCloseSummaryModal}
      />
    </section>
  );
};

export default RetireOnlineRequiredActions;
